import { connect } from 'common/sockets/zap';

export default (token) => connect(token);
